// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__22uR7","info":"Note_info__3ifsW","note":"Note_note__3jy1Q","actions":"Note_actions__TQ2Yf"};